import { render, staticRenderFns } from "./DeclarRecord.vue?vue&type=template&id=0ce2f162&scoped=true"
import script from "./DeclarRecord.vue?vue&type=script&lang=js"
export * from "./DeclarRecord.vue?vue&type=script&lang=js"
import style0 from "./DeclarRecord.vue?vue&type=style&index=0&id=0ce2f162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce2f162",
  null
  
)

export default component.exports